// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__1Neu5","floatSpinner":"Spinner_floatSpinner__36mUW"};